import React from 'react'
import { CustomFormProps } from 'types/common'
import StandardPricingInput from 'ui-shared/FormComponents/pricing/standard/StandardPricingInput'
import SingleImageInput from 'ui-shared/WrappedInputs/SingleImageInput'
import ProductForm from './ProductForm'

const LogisticsForm: React.FC<CustomFormProps> = (props) => {
  return (
    <ProductForm {...props}>
      <SingleImageInput />
      <StandardPricingInput hideVariablePrice isSinglePriceRange />
    </ProductForm>
  )
}

export default LogisticsForm
